/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';


import styles from '../../../../styles';
import { RadioGroup } from '../../../../components/Form';
import QuickFind from '../../../../../shared/components/QuickFind';
import ServiceSeverityGrid from '../ServiceSeverityGrid';

const Wrapper = styled.div`
  background-color: white;
  padding: 0rem;
  overflow-y: scroll;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
`;

const Value = styled.div`
  ${styles.fonts.base};
  color: ${styles.colors.biscay};
`;

const Grid = styled.div`
  margin-top: 1rem;
`;

class ServiceSubscriptionPage extends React.Component {
  render() {
    return (
      <Wrapper>
        {/* <Label>
          Instance
        </Label>
        <Value>
          {this.props.instanceKey}
        </Value>
        <Grid> */}
          {/* <Label>
            Select Services and Severities
          </Label> */}
          <ServiceSeverityGrid
            serviceSeverityGrid={this.props.serviceSeverityGrid}
            closeModal={this.props.onClose}
            requests={this.props.requests}
            instanceKey = {this.props.instanceKey}
          />
        {/* </Grid> */}
      </Wrapper>
    );
  }
}

export default ServiceSubscriptionPage;
